/*
  Линия курсора
*/
export class CursorPlotLine {
  // Объект графика
  private chart: any;

  // Объект plotLine
  private plotLine: any;

  // Значение курсора по оси X
  private xValue: any;

  // Объект plotLine с svg элементом
  private svgPlotLine: any;

  // Показатель перемещения линии
  private drag = false;

  // Координата по оси X точки клика по линии
  private clickX: any;

  refValue: any;

  // Показатель заморозки событий
  private isFreeze = false;

  // Показатель возможности перетаскивания линии
  private canDrag: boolean;

  // Индекс линии
  public index!: number | null;

  constructor(chart: any, plotLine: any, canDrag = true, index: number | null = null) {
    this.chart = chart;
    this.plotLine = plotLine;
    this.canDrag = canDrag;
    this.index = index;
  }

  // Заморозить события
  freezeEvents(freeze: boolean) {
    this.isFreeze = freeze;
  }

  // Начало перемещения
  startDrag() {
    this.drag = true;
  }

  // Окончание перемещения
  stopDrag() {
    this.drag = false;
    // необходима перерисовка, чтобы обновился объект plotLine
    this.redraw();
  }

  // Показатель перемещения
  isDrag() {
    return this.drag;
  }

  // Переместить по оси x
  translateX(pageX: number, chartX: number) {
    const xAxis = this.chart.xAxis[0];
    const extremes = this.chart.xAxis[0].getExtremes();
    if (
      chartX < Math.floor(xAxis.toPixels(extremes.dataMin) + 1) ||
      chartX > Math.floor(xAxis.toPixels(extremes.dataMax))
    )
      return;
    const newTranslation = pageX - this.clickX;
    this.svgPlotLine.svgElem.translate(newTranslation);
    this.xValue = xAxis.toValue(newTranslation) - xAxis.toValue(0) + this.plotLine.value;
    return this.xValue;
  }

  // Получить переведенное из пикселей в координаты графика значение по оси X
  getTranslatedXValue(pageX: number) {
    const xAxis = this.chart.xAxis[0];
    //    return xAxis.toValue(pageX - this.clickX) - xAxis.toValue(0) + this.plotLine.value;
    return xAxis.toValue(pageX - this.clickX) - xAxis.toValue(0) + this.refValue;
  }

  // Перерисовать
  redraw(value: any = null) {
    this.remove();
    if (!value) value = this.xValue;
    if (!value) return;

    this.plotLine.value = value;
    if (!this.drag) this.refValue = this.plotLine.value;
    this.xValue = value;
    this.svgPlotLine = this.chart.xAxis[0].addPlotLine(this.plotLine);
    if (!this.svgPlotLine || !this.canDrag) return;
    this.svgPlotLine.svgElem.css({'cursor': 'pointer'}).translate(0, 0);
    this.svgPlotLine.svgElem.element.onmousedown = (e: any) => {
      //      if (this.isFreeze) return;
      this.clickX = e.pageX - this.svgPlotLine.svgElem.translateX;
      this.refValue = this.plotLine.value;
      this.startDrag();
      e.stopPropagation();
    };
  }

  // Удалить plotLine с графика
  remove() {
    const findedLine = this.chart.xAxis[0].plotLinesAndBands.find(
      (e: any) => e.id === this.plotLine.id,
    );
    if (findedLine) this.chart.xAxis[0].removePlotLine(this.plotLine.id);
  }
}
